<template>
<div>

    <!-- <headerNav title="我的订单" /> -->
    <navsearch placeholder="搜索收件人或收件号码" @onsearch="onsearch"></navsearch>
    
    <van-tabs v-model="tabCurrentIndex" @change="tabchange" sticky>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-tab :title="navitem.text" v-for="(navitem,navindex) in navList" :key="navindex">
                <van-list v-model="navitem.loaded" :finished="navitem.loadingType=='nomore'?true:false" :finished-text="navitem.loadingType=='nomore'?'没有更多了':'下拉加载更多'" @load="loadData">
                    <div v-for="(item,index) in navitem.orderList" :key="index">
                        <van-cell-group class="order-item">
                            <van-panel :title="'订单：'+item.tid" :status="item.orderStatusEnumName">
                                <div slot="header">
                                    <van-cell class="title" :title="'订单：'+item.tid" :value="item.splitOrderState==1?item.deliveryStatus==1?'部分发货':item.orderStatusEnumName:item.orderStatusEnumName" />
                                </div>
                                <div style="padding:8px 16px">
                                    <div><span>收件人:{{item.receiverName}}</span>     <span style="margin-left:5px">收件号码:{{item.receiverMobile}}</span></div>
                                    <div>收货地址:{{item.receiverCity+item.receiverAddress}}</div>
                                </div>
                                <div>
                                    <div>
                                        <div v-for="(product,i) in item.tradeDetails" :key="i">
                                            <trade-card :product='product' :isshowsend="(item.orderStatusEnum==1&&item.deliveryStatus!=0)||(item.orderStatusEnum==2&&item.buyerRefundStatus==0)"/>
                                        </div>
                                    </div>
                                </div>
                                <div slot="footer">
                                    <div class="total">总价：￥{{item.payment}}</div>
                                </div>
                            </van-panel>
                        </van-cell-group>

                    </div>

                </van-list>
            </van-tab>
        </van-pull-refresh>
    </van-tabs>

</div>
</template>

<script>
import request from "@/config/ajax";
export default {
    components: {},
    data() {
        return {
            isLoading: false,
            refreshing: false,
            tabCurrentIndex: 0,
            navList: [
                {
                    state: 0,
                    text: '待发货',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "tid": "",
                        "name": "",
                        "sku": "",
                        "nameOrPhone":"",
                        "halfPriceState":1,
                        "productSku": "",
                        "refundStatus": 0,
                        "sorting": "",
                        "maxResultCount": 10,
                        "skipCount": 0,
                        "isHalfPriceOrder":true
                    },
                    orderList: []
                },
                {
                    state: 0,
                    text: '已发货',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "tid": "",
                        "name": "",
                        "sku": "",
                        "nameOrPhone":"",
                        "halfPriceState":2,
                        "productSku": "",
                        "refundStatus": 0,
                        "sorting": "",
                        "maxResultCount": 10,
                        "skipCount": 0,
                        "isHalfPriceOrder":true
                    },
                    orderList: []
                }
                // {
                //     state: 5,
                //     text: '退款',
                //     loadingType: 'more',
                //     loaded:false,
                //     getparams: {
                //         "tid": "",
                //         "name": "",
                //         "sku": "",
                //         "orderStateList": [1, 2],
                //         "productSku": "",
                //         "refundStatus": 1,
                //         "sorting": "",
                //         "maxResultCount": 10,
                //         "skipCount": 0
                //     },
                //     orderList: []
                // }
            ],
            paydto: {
                tid: ''
            },
            diffmoney:0,
            moneyload:false
        }
    },
    created() {
        
        var option = this.$route.query;

        if (option.state) {
            this.tabCurrentIndex = Number.parseInt(option.state);
        }
        this.loadData();
    },
    methods: {
        tabchange() {
            this.loadData('tabChange');
        },
        onRefresh() {
            this.loadData('refresh');
        },
        logisticinfo(item) {
            // this.$router.push({
            //     path: '/logistics',
            //     query: {
            //         tid: item.tid
            //     }
            // });
             this.$router.push({
                path: '/logisticstrajectory',
                query: {
                    tid: item.tid
                }
            });
        },
        onsearch(val){

            this.navList.forEach(x=>{
                x.getparams.nameOrPhone=val;
                x.loadingType='refresh';
            })
            this.loadData();
        },
        loadData(source) {
            //这里是将订单挂载到tab列表下
            let index = this.tabCurrentIndex;
            let navItem = this.navList[index];
            // let state = navItem.state;

            if (source === 'tabChange' && navItem.loaded === true) {
                //tab切换只有第一次需要加载数据
                return;
            }
            if (navItem.loadingType === 'loading' || navItem.loadingType === 'nomore') {
                if (source != "refresh") {
                    return;
                }
            }
            if(navItem.loadingType=='refresh')
            {
                this.navList[index].orderList = [];
                this.navList[index].getparams.skipCount = 0;
            }
            if (source === 'refresh') {
                this.navList[index].orderList = [];
                this.navList[index].getparams.skipCount = 0;
            }
            navItem.loadingType = 'loading';
            var params = navItem.getparams;
            //加载数据
            request.post('/api/services/app/PhoneTrade/QueryOrder', params).then(x => {

                this.navList[index].getparams.skipCount += this.navList[index].getparams.maxResultCount;
                let totalcount = x.result.totalCount;
                this.navList[index].orderList = this.navList[index].orderList.concat(x.result.items);
                //console.log(this.navList);
                // item = Object.assign(item, this.orderStateExp(item.state));
                this.navList[index].loadingType = totalcount > (this.navList[index].getparams.skipCount) ? 'more' : 'nomore';
            }).finally(() => {
                this.navList[index].loaded = false;
                this.refreshing = false;
            });

        }
        
    }
}
</script>

<style lang="scss" scoped>
.cheader{
    padding: 5px 10px 10px 10px;
    background-color: #fff;
    border-bottom:1px solid #e6e6e6;
}
.cmoneys
{
    display: inline-block;
    width: 50%;
    font-size: 14px;
    color:#c6bcf8;
}
.cmoney-money
{
    font-size: 25px;
}
.order-item {
    font-size: 12px;
    margin: 10px 10px 10px 10px;
    box-shadow: 1px 1px 4px #d0d0d0;
}

.title {
    border-bottom: 1px solid #e5e5e5;
}

.van-cell__title {
    flex: 2;
}

.van-cell__value {
    color: red;
}

.van-panel__footer {
    text-align: right;
    border-bottom: 1px solid #e5e5e5;
}

.van-button {
    margin-left: 5px;
}

.total {
    font-size: 14px;
    text-align: left;
}

.more {
    overflow-x: scroll;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    margin: 5px 0 5px 15px;
}

.item {
    width: 90px;
    height: 90px;
    margin-right: 10px;
    display: inline-block;

}

.item img {
    width: 100%;
}
</style>
